<form class="routed-component-layout" [formGroup]="form" novalidate autocomplete="off">

  <div class="routed-component-body">

    <div class="routed-component-title-block">
      <h2>{{'REGISTRATION.COMPANY_STEP.REGISTERED_ADDRESS.TITLE' | translate}}</h2>

      <h5 *ngIf="selectedCountry == 'GBR'">
        {{'REGISTRATION.COMPANY_STEP.REGISTERED_ADDRESS.GBR_SEARCH_HELP' | translate}}
      </h5>
    </div>

    @if (form) {
    <div class="field-group-layout">
      <h4>{{'REGISTRATION.COMPANY_STEP.REGISTERED_ADDRESS.TITLE_FORM' | translate}}</h4>
      <div data-cy="Company_Address_RegisteredAddress">

        <address3-form-group
          [disableCountrySelection]="true"
          [addressFormGroup]="form"
          [activeMarketsOnly]="onlyActiveMarket"
          [translatedCountries]="translatedCountries"
          data-cy="Company_Address_RegisteredAddress">
        </address3-form-group>

      </div>
    </div>
    }
  </div>

    <!-- Sub-Step Navigation -->
    <div class="navigation-controls-layout">

      <div class="routed-component-cta">
        <button type="button" (click)="previousStep()" [disabled]="loading" data-cy="Signup_Button_PreviousStepButton">
          {{ 'REGISTRATION.COMPANY_STEP.PREVIOUS_SUB_STEP_BUTTON' | translate }}
        </button>

        <button type="submit" class="primary" (click)="nextStep()" [disabled]="loading"
          [ngClass]="{ 'loading': loading}" data-cy="Signup_Button_NextStepButton">
          {{ 'REGISTRATION.COMPANY_STEP.NEXT_SUB_STEP_BUTTON' | translate}}
        </button>
      </div>

      <save-and-continue-later stepName="Company Registered Address"></save-and-continue-later>
    </div>


  </form>
